<template>
  <section class="promotion-detail">
    <div class="abs-top-right">
      <v-button @click="() => $router.back()">Back</v-button>
    </div>
    <div class="header">
      <h1>Promotion</h1>
      <!-- <span
        v-if="status === 0"
        class="span-checkbox warning">Draft</span>
      <span
        v-if="status === 2"
        class="span-checkbox">Scheduled</span>
      <span
        v-if="status === 1"
        class="span-checkbox success">Published</span>
      <span
        v-if="status === 3"
        class="span-checkbox info">Unpublished</span> -->
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="content-container">
        <div>
          <h3>English</h3>
          <div class="form-item">
            <span>Title</span>
            <el-form-item
              :rules="rules.input"
              prop="data.en.title">
              <v-input v-model="formData.data.en.title" />
            </el-form-item>
          </div>
          <el-form-item
            :rules="rules.input"
            prop="data.en.content">
            <div class="content-box">
              <!-- <v-quill-editor v-model="formData.data.en.content" /> -->
              <v-editor
                ref="en-editor"
                :otherData="{
                  'target': 'en'
                }"
                @save="handlerSaveEditor" />
            </div>
          </el-form-item>
        </div>
        <div>
          <h3>Chinese (Traditional)</h3>
          <div class="form-item">
            <span>Title</span>
            <el-form-item
              :rules="rules.input"
              prop="data.hk.title">
              <v-input v-model="formData.data.hk.title" />
            </el-form-item>
          </div>
          <el-form-item
            :rules="rules.input"
            prop="data.hk.content">
            <div class="content-box">
              <!-- <v-quill-editor v-model="formData.data.hk.content" /> -->
              <v-editor
                id="editorjsHK"
                ref="hk-editor"
                :otherData="{
                  'target': 'hk'
                }"
                @save="handlerSaveEditor" />
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="content-form">
        <div>
          <h2>Promotion Settings</h2>
          <div class="form-item">
            <span>Post Category</span>
            <el-form-item
              :rules="rules.select"
              prop="category_id">
              <v-select
                v-model="formData.category_id"
                :list="categoriesList" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Promoted Product</span>
            <el-form-item
              :rules="rules.select"
              prop="product_id">
              <v-select
                v-model="formData.product_id"
                :list="productTypeOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Cover Image</span>
            <v-checkbox
              v-model="coverImage"
              class="mg-b-5">Separate cover images for each language</v-checkbox>
            <div v-if="!coverImage">
              <img
                v-if="formData.data['en'].cover_image_url"
                class="cover-image"
                :src="formData.data['en'].cover_image_url" />
              <el-form-item
                :rules="rules.upload"
                prop="data.en.cover_image_url">
                <v-upload 
                  :notUpload="true"
                  :otherData="{
                    lang: 'en'
                  }"
                  @uploadForm="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div
              v-else
              class="cover-list">
              <div class="cover-item">
                <span>English</span>
                <img
                  v-if="formData.data['en'].cover_image_url"
                  class="cover-image"
                  :src="formData.data['en'].cover_image_url" />
                <el-form-item
                  :rules="rules.upload"
                  prop="data.en.cover_image_url">
                  <v-upload 
                    :notUpload="true"
                    :otherData="{
                      lang: 'en'
                    }"
                    @uploadForm="handlerUploadSuccess" />
                </el-form-item>
              </div>
              <div class="cover-item">
                <span>Chinese (Traditional)</span>
                <img
                  v-if="formData.data['hk'].cover_image_url"
                  class="cover-image"
                  :src="formData.data['hk'].cover_image_url" />
                <el-form-item
                  :rules="rules.upload"
                  prop="data.hk.cover_image_url">
                  <v-upload 
                    :notUpload="true"
                    :otherData="{
                      lang: 'hk'
                    }"
                    @uploadForm="handlerUploadSuccess" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-item">
            <span>Privacy</span>
            <v-checkbox v-model="formData.privacy" >Do not show in list</v-checkbox>
          </div>
        </div>
        <div>
          <h2>Publish</h2>
        
          <div class="flex publish-container">
            <div class="form-item">
              <span>Start Date</span>
              <el-form-item
                :rules="rules.select"
                prop="start_date">
                <v-date-picker v-model="formData.start_date" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>End Date</span>
              <el-form-item
                :rules="rules.select"
                prop="end_date">
                <v-date-picker v-model="formData.end_date" />
              </el-form-item>
            </div>
          </div>
          <v-button
            type="primary"
            @click="handlerSave">Save</v-button>


        </div>
      </div>
    </el-form>
  </section>
</template>
<script>
import { 
  addPromoArticle,
  getPromoCategoriesList,
  getPromoArticleDetail,
  updatePromoArticleDetail,
  deletePromoArticle,
  uploadNewsImage } from '@/api/news'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'PostDetail',
  mixins: [MixinOptions, MixinRules],
  data() {
    return {
      categoriesList: [],
      coverImage: false,
      formData: {
        // status: -1, // 前端監聽用
        category_id: '',
        product_id: '',
        privacy: 0,
        data: {
          en: {
            title: '',
            description: '接口必填',
            content: '',
            cover_image_file_id: '',
            cover_image_url: ''
          },
          hk: {
            title: '',
            description: '接口必填',
            content: '',
            cover_image_file_id: '',
            cover_image_url: ''
          }
        },
        start_date: '',
        end_date: ''
      },
    }
  },
  computed: {
    articleId() {
      return this.$route.query.id
    },
    isEdit() {
      return this.articleId? true: false
    },
    // status() {
    //   return this.formData.status
    // }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getPromoCategoriesList()
        if(this.articleId) {
          this.network().getPromoArticleDetail()
        }
      }
    },
    'formData.data.en.content': {
      handler(val) {
        if(val !== '') {
          this.$refs.form.clearValidate(['data.en.content'])
        }
      }
    },
    'formData.data.hk.content': {
      handler(val) {
        if(val !== '') {
          this.$refs.form.clearValidate(['data.hk.content'])
        }
      }
    },
  },
  methods: {
    onDelete() {
      this.network().deletePromoArticle()
    },
    handlerSaveEditor({ data, otherData }) {
      const { target } = otherData

      if(target == 'en') {
        this.$set(this.formData.data.en, 'content', data)
      }
      else {
        this.$set(this.formData.data.hk, 'content', data)
      }
    },
    async handlerSave() {
      await this.$refs['en-editor'].handlerSave()
      await this.$refs['hk-editor'].handlerSave()

      this.$refs.form.validate(valid => {
        if(valid) {
          let params = this.handler().handlerFormData()
          if(this.articleId) {
            this.network().updatePromoArticleDetail(params)
          }
          else {
            this.network().addPromoArticle(params)
          }
        }
      })
      
    },
    handlerUploadSuccess({ params, result, otherData }) {
      // 這裏還要上傳
      this.network().uploadNewsImage({ params, result, otherData })
    },
    handler() {
      return {
        handlerFormData: () => {
          let params = JSON.parse(JSON.stringify(this.formData))
          params.privacy = params.privacy? 1: 0
          if(!this.coverImage) {
            params.data.hk.cover_image_file_id = params.data.en.cover_image_file_id
          }
          return params
        }
      }
    },
    network() {
      return {
        addPromoArticle: async params => {
          const { data } = await addPromoArticle(params)
          this.$router.push({
            path: '/administration/web/content',
            query: {
              tab: 'Promos'
            }
          })
        },
        updatePromoArticleDetail: async params => {
          const { data } = await updatePromoArticleDetail({
            ...params,
            article_id: this.articleId
          })
          this.$router.push({
            path: '/administration/web/content',
            query: {
              tab: 'Promos'
            }
          })
        },
        getPromoArticleDetail: async () => {
          let { data } = await getPromoArticleDetail({
            article_id: this.articleId
          })
          data.privacy = data.privacy === 1? true: false
          data.data = data.data.reduce((result, item) => {
            if(item.language == 'en-US') {
              result['en'] = item
            } else {
              result['hk'] = item
            }
            return result
          }, {})
          if(data.data['hk'] && data.data['hk'].cover_image_file_id == data.data['en'].cover_image_file_id) {
            this.coverImage = false
          }
          else {
            this.coverImage = true
          }
          this.formData = Object.assign(this.formData, data)

          // 初始化富文本編輯器內容
          setTimeout(() => {
            this.$refs['en-editor'].initData(this.formData.data.en.content)
            this.$refs['hk-editor'].initData(this.formData.data.hk.content)
          }, 400)
          
        },
        getPromoCategoriesList: async () => {
          let { data } = await getPromoCategoriesList({
            hideLoading: true
          })
          const list = data.reduce((result, item) => {
            result.push({
              id: item.category_id,
              name: item.name
            })
            return result
          }, [])
          this.categoriesList = list
        },
        deletePromoArticle: async () => {
          const { data } = await deletePromoArticle({
            article_id: this.articleId
          })
          this.$router.push({
            path: '/administration/web/content',
            query: {
              tab: 'Promos'
            }
          })
        },
        uploadNewsImage: async ({ params, result, otherData }) => {
          const { data } = await uploadNewsImage(params)
          const { lang } = otherData
          const { url } = result
          this.$set(this.formData.data[lang], 'cover_image_file_id', data.image_id)
          this.$set(this.formData.data[lang], 'cover_image_url', url)
          this.$message({
            type: 'success',
            message: 'Upload Success'
          })

          this.$refs['form'].clearValidate([`data.${lang}.cover_image_url`])

        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.promotion-detail {
    position: relative;
    padding-bottom: 200px;
    .header {
        h1 {
            display: inline-block;
            padding-right: 15px;
        }
    }
    .content-container, .content-form {
        display: flex;
        justify-content: space-between;
        & > div {
            width: calc(50% - 10px);
        }
    }
    .content-form {
      margin-top: 20px;
    }
    .content-box {
        // margin-bottom: 15px;
        min-height: 400px;
    }
    .cover-image {
      max-width: 100px;
      max-height: 100px;
    }
    .cover-list {
      display: flex;
      .cover-item {
        flex: 1;
        & > span:first-child {
          display: block;
          padding-bottom: 5px;
          color: #616266;
          font-size: 14px;
        }
      }
    }
    .publish-container {
    .form-item {
      margin-right: 15px;
    }
  }
}
</style>